import ProductApi from "../../../../services/api/productApi";

const ProductApiService = new ProductApi();

export default {
  inject: ["$validator"],

  props: {
    product: { type: Object },
  },

  data() {
    return {
      loading: false,
      name: "",
    };
  },

  methods: {
    validate,
    close,
    submit,
  },

  mounted() {
    this.name = "Copy of " + this.product.name;
  },
};

function validate() {
  this.$validator.validate().then((valid) => {
    if (!valid) return;

    this.submit();
  });
}

function submit() {
  this.loading = true;
  this.$loader.$emit("trigger", true);

  ProductApiService.duplicate({ id: this.product.id, name: this.name })
    .then(() => {
      this.$swal("Success", "Product duplicated successfully!");
      this.close(true);
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    })
    .finally(() => {
      this.loading = false;
      this.$loader.$emit("trigger", false);
    });
}

function close(pullProducts) {
  this.$emit("close-duplicate-product-modal", pullProducts);
}
